import { CONFIG } from "../CONFIG"

type Params = {
  [key: string]: number | string | Array<string> | undefined | boolean
}

export const getStorageUrl = () => {
  if (process.env.NODE_ENV === "development") {
    return `${CONFIG.DEV_HOST}${CONFIG.STORAGE_URL}`
  }

  return CONFIG.STORAGE_URL
}
export const removeEmptyParams = (query: Params) => {
  return Object.keys(query).reduce(
    (acc, param) =>
      typeof query[param] !== "boolean" && (!query[param] || query[param] === "unset")
        ? acc
        : { ...acc, [param]: query[param] },
    {}
  )
}
